import { FormOverrideAddressFieldset } from '@domgen/dgx-fe-forms/address';
import { FormField } from '@domgen/dgx-fe-forms/layout';
import { CmsGroupMarketingPreferencesFieldset } from '../group-marketing-preferences/cms-group-marketing-preferences-fieldset.interface';

export interface CmsPersonalDetailsForm {
  addressFieldset: FormOverrideAddressFieldset;
  groupMarketingPreferencesFieldset: CmsGroupMarketingPreferencesFieldset;
  emailAddressField: FormField;
  firstNameField: FormField;
  lastNameField: FormField;
  marketingConsentNote: string;
  marketingPreferenceEmailField: FormField;
  marketingPreferencePostField: FormField;
  marketingPreferenceTelephoneField: FormField;
  privacyPolicyField: FormField;
  telephoneNumberField: FormField;
  titleIdField: FormField;
}
